// Фильтры - сброс +
// Таблица - сброс + 
// url - логика +
import customHeaders, { getSpace } from '../../common/headers';
import refresh_icon from './img/refresh_icon.svg';
import { useDataTable } from '../../common/hooks';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef, useCallback } from 'react';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import {
  DropDownSelector,
  SearchComponent,
  ButtonBasic,
  TableBox,
} from '@lk-gtcom/ecomlab-components';
import {
  fetchFilterV3,
  fetchWarehouseFilter,
} from '../../common/filtersFunc';
import { KonstantinCreateProductHttps } from '../../fetchUrls';
import useGeneralStore from '../../store/general';
import './SetRemainingGoods.scss';
import { RequestController } from '../../common/filtersFunc';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { periodWeek } from '../../common/constant';
import { useResponseHandler } from '../../common/auth';
import { useSavedFilters } from '../../common/useSavedFilters';

const SetRemainingGoods = () => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved,  hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'set-remaining-goods');
  const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();
  // Реф для хранения контроллера запросов
  const requestControllerRef = useRef(new RequestController());
  const [pageValue, setPageValue] = useState('product');

  // Поиск
  const [searchValue, setSearchValue] = useState('');
  const [searchData, setSearchData] = useState([]);
  const [defaultSearchValue, setDefaultSearchValue] = useState('')

  // Фильтры
  const filterConfig = [
    { key: 'api', type: 'single' },
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
    { key: 'warehouse', type: 'multi' },
    { key: 'search', type: 'single' }
  ];
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  const [apiData, setApiData] = useState([]);
  const [warehouseData, setWarehouseData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);

  const [selectedApi, setSelectedApi] = useState(null);
  const [selectedWarehouse, setSelectedWarehouse] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);

  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);
  const [apiPage, setApiPage] = useState(1);

  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0);
  const [totalWarehouse, setTotalWarehouse] = useState(0);

  const [warehousePage, setWarehousePage] = useState(1);
  const [warehouseQuery, setWarehouseQuery] = useState('');

  const [date, setDate] = useState(periodWeek());
  const [dateFrom, dateTo] = date;

  const activeTab = useParams()['*'];

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;

  // Инициализация фильтров из URL параметров при первом рендере
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  useEffect(() => {
    if (!isReady) return;
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.api) setSelectedApi(urlParams.api)
        if (urlParams.category) setSelectedCategory(urlParams.category)
        if (urlParams.brand) setSelectedBrand(urlParams.brand)
        if (urlParams.warehouse) setSelectedWarehouse(urlParams.warehouse)
        if (urlParams.search) {
          setSearchValue(urlParams.search?.value)
          setDefaultSearchValue({
            value: urlParams.search?.value,
            label: urlParams.search?.label
          })
        }

        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady]);

  useEffect(() => {
    if (!isReady) return;
    updateURL({
      api: urlParams?.api || selectedApi,
      category: urlParams?.category || selectedCategory,
      brand: urlParams?.brand || selectedBrand,
      warehouse: urlParams?.warehouse || selectedWarehouse,
      search: urlParams?.search ? urlParams.search?.value : null
    })
  }, [isReady]);

  const resetTable = () => {
    paginatorRef.current?.reset();
    paginatorRef.current?.setTotal(0);
    setSort({});
    setHeaders([]);
    setFetchedData([]);
  };

  // Таблица
  const fetchTableData = (params, abortController = new AbortController()) => {
    if (!selectedApi?.value) {
      resetTable()
      return
    }

    let sort;
    let filtersParam;

    if (params) {
      [sort, filtersParam] = params;
    }

    setLoading(true);

    let url = `https://apps0.ecomru.ru:4449/mp-products/tables/stocks${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''}`;

    const body = JSON.stringify({
      warehouse_id_list: getValueMultiFilter(selectedWarehouse),
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      api_id_list: getValueMultiFilter(selectedApi),
      page: paginatorRef.current.page,
      limit: paginatorRef.current.limit,
      filters: filtersParam,
      offer_id_name_search: searchValue,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController?.signal.aborted) return
        setLoading(false)
      });
  };

  // Поиск
  const fetchSearch = ([search, page = 1], abortController = new AbortController()) => {
    // let url = `${KonstantinMasterHttps}/mp-products/filters/offer-id-name`;
    let url = `https://apps0.ecomru.ru:4449/v2/mp-products/filters/wh-offer-id-name`;

    const body = JSON.stringify({
      api_id_list: getValueMultiFilter(selectedApi),
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      warehouse_id_list: getValueMultiFilter(selectedWarehouse),
      page: page,
      limit: 10,
      search_param: search,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => {
        let result = [];
        if (json?.filter_data) {
          result = json?.filter_data?.map(({ id, name, image }, ind) => {
            return { label: name, value: id, image: image };
          });
        }
        setSearchData(result);
      })
      .catch(handleRequestError);
  };

  useEffect(() => {
    setPageValue(activeTab);
  }, [activeTab]);

  const filtersApi = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      page: apiPage,
      set: setApiData,
      searchParam: apiQuery,
      controller,
      setTotal: setTotalApi,
      filter: 'mp_product_api_ids'
    })?.finally(() => {
      requestControllerRef.current.removeController('api');
    })
  };

  const filtersCategory = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      selectedApi,
      page: categoryPage,
      set: setCategoryData,
      searchParam: categoryQuery,
      controller,
      setTotal: setTotalCategory,
      filter: 'mp_product_categories'
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  };

  const filtersBrand = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchFilterV3({
      selectedSpace: selectedSpace?.value,
      page: brandPage,
      selectedApi,
      selectedCategory,
      searchParam: brandQuery,
      set: setBrandData,
      controller,
      setTotal: setTotalBrand,
      filter: 'mp_product_brands'
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  };

  const filtersWarehouse = () => {
    const controller = requestControllerRef.current.createController('warehouse');

    fetchWarehouseFilter({
      controller,
      selectedSpace: selectedSpace?.value,
      page: warehousePage,
      apiData,
      categoryData,
      selectedApi,
      selectedCategory,
      selectedBrand,
      brandData,
      dateFrom,
      dateTo,
      searchParam: warehouseQuery,
      setWarehouseData: (e) => setWarehouseData(e),
    })?.finally(() => {
      requestControllerRef.current.removeController('warehouse');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersApi()
  }, [isFilterRequest, apiPage, apiQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersCategory()
  }, [isFilterRequest, date, categoryPage, categoryQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersBrand()
  }, [isFilterRequest, date, brandPage, brandQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersWarehouse()
  }, [isFilterRequest, date, warehousePage, warehouseQuery]);

  useEffect(() => {
    return () => {
      // Отменяем все активные запросы фильтров
      requestControllerRef.current.abortAll();
    };
  }, []);

  useEffect(() => {
    if(!isReady)return
    const abortController = new AbortController();
    fetchTableData([], abortController);
    return () => abortController.abort();
  }, [isTableRequest]);

  const handleSearch = useCallback((e) => {
    if(!isReady)return
    const abortController = new AbortController();
    fetchSearch(e, abortController);
    return () => abortController.abort();
  });

  const fetchUpdateOneStock = (
    apiId,
    mpId,
    warehouseId,
    offerId,
    stock,
    setStatus
  ) => {
    let url = `${KonstantinCreateProductHttps}/mp_products/stocks`;

    const stocks = [
      {
        offer_id: offerId,
        warehouse_id: warehouseId,
        stock: stock,
      },
    ];
    const body = JSON.stringify({
      mp_id: mpId,
      api_id: apiId,
      stocks,
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then(() => setTimeout(() => setIsTableRequest(!isTableRequest), 300))
      .catch((err) => {
        setStatus('error');
        handleRequestError(err);
      });
  };

  const handleSaveOneRemainder = (e) => {
    const { inputEvent, actionEvent, setStatus } = e;
    const offerId = inputEvent?.id;
    const stock = +inputEvent?.value;
    const mpId = actionEvent?.[0]?.mp_id;
    const apiId = actionEvent?.[0]?.api_id;
    const warehouseId = actionEvent?.[0]?.warehouse_id;

    if (offerId && stock && apiId && mpId && warehouseId) {
      setStatus('loading');
      fetchUpdateOneStock(apiId, mpId, warehouseId, offerId, stock, setStatus);
    } else {
      setStatus('error');
    }
  };

  return (
    <div className="set-remaining-goods">
      <TitlePage
        title='Установка остатков'
      />

      <div className="set-remaining-goods__filters">
        <FilterContainer
          loading={isSaved}
          saveFilters={saveFilters}
          clearSavedFilters={clearSavedFilters}
        hasSavedFilters={hasSavedFilters}
          onReset={(e) => {
            setSelectedApi([])
            setSelectedWarehouse([]);
            setSelectedCategory([]);
            setSelectedBrand([]);
            setSearchValue('')
            setSearchData([])
            updateURL({
              api: null,
              category: null,
              brand: null,
              offerId: null,
              search: null
            });
            setIsTableRequest(!isTableRequest)
            setIsFilterRequest(!isFilterRequest)
          }}
        >
          <DropDownSelector
            options_prop={apiData}
            state={selectedApi}
            setState={setSelectedApi}
            placeholder="Магазин"
            total={totalApi}
            fetchCallback={setApiPage}
            setInputChange={setApiQuery}
            onBlur={() => {
              updateURL({ api: selectedApi });
              filtersCategory()
              filtersBrand()
              filtersWarehouse()
              setIsTableRequest(!isTableRequest)
            }}
          />

          <DropDownSelector
            options_prop={categoryData}
            state={selectedCategory}
            setState={setSelectedCategory}
            placeholder="Категория"
            total={totalCategory}
            fetchCallback={setCategoryPage}
            setInputChange={setCategoryQuery}
            multi
            onBlur={(e) => {
              updateURL({ category: selectedCategory });
              filtersBrand()
              filtersWarehouse()
              setIsTableRequest(!isTableRequest)
            }}
          />
          <DropDownSelector
            options_prop={brandData}
            state={selectedBrand}
            setState={setSelectedBrand}
            placeholder="Бренд"
            total={totalBrand}
            fetchCallback={setBrandPage}
            setInputChange={setBrandQuery}
            onBlur={() => {
              updateURL({ brand: selectedBrand });
              filtersWarehouse()
              setIsTableRequest(!isTableRequest)
            }}
            multi
          />

          <DropDownSelector
            options_prop={warehouseData}
            state={selectedWarehouse}
            setState={setSelectedWarehouse}
            fetchCallback={setWarehousePage}
            setInputChange={setWarehouseQuery}
            placeholder="Склад"
            total={totalWarehouse}
            multi
            onBlur={() => {
              updateURL({ warehouse: selectedWarehouse });
              setIsTableRequest(!isTableRequest)
            }}
          />
          <SearchComponent
            searchValue={searchValue}
            errSearch={false}
            placeholder="Поиск товара"
            errText="Неверный товар"
            setSearchValue={setSearchValue}
            fetchData={(e) => setIsTableRequest(!isTableRequest)}
            fetchCallback={handleSearch}
            data={searchData}
            onClearDependence={[isFilterRequest]}
            updateURL={updateURL}
            value={defaultSearchValue}
          />
        </FilterContainer>
      </div>

      <TableBox
        {...tableProps}
        paginator={true}
        ref={paginatorRef}
        fetchCallback={fetchTableData}
        onInputAction={handleSaveOneRemainder}
        child={<ButtonBasic
          violet
          onClick={(e) => setIsTableRequest(!isTableRequest)}
          icon={refresh_icon}
          text={'Обновить остатки'}
          width="auto"
          size="32px"
        />}
      />
    </div>
  );
};

export { SetRemainingGoods };
